import { render, staticRenderFns } from "./LanguagesFields.vue?vue&type=template&id=7263a2a8&"
import script from "./LanguagesFields.vue?vue&type=script&lang=js&"
export * from "./LanguagesFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports